import {Config} from "../config";


export class CableColor {
  gridElementId: number;
  la: string;
  laGP: string;
  constructor(id: number, color?: string) {
    this.gridElementId = id;
    this.la = color ? color : Config.CONDITION_COLOR_NORMAL;
    this.laGP = color ? color : Config.CONDITION_COLOR_NORMAL;
  }

  public static getHighestColorInArray(colorArray?: string[]): string {
    let highestColor = Config.CONDITION_COLOR_NORMAL;
    const mapColor = new Map([ [Config.CONDITION_COLOR_NORMAL, 0], [Config.CONDITION_COLOR_ATTENTION, 1], [Config.CONDITION_COLOR_PROBLEM, 2] ]);
    const colorSortMap: Map<number, string> = new Map<number, string>();
    colorArray.forEach(color => {
      colorSortMap.set(mapColor.get(color), color);
    });
    const index = Array.from(colorSortMap.keys()).sort((n1: number, n2: number) => n2 - n1)[0];
    highestColor = colorSortMap.get(index);
    console.log('met. High. color: ' + highestColor);
    return highestColor;
  }
}
